export var TestIds;
(function (TestIds) {
  TestIds["CONTRIBUTOR_SECTION"] = "contributor-section";
  TestIds["DELETE_CONTRIBUTOR_BUTTON"] = "delete-annotation-icon-button";
  TestIds["ADD_CONTRIBUTOR_LINK"] = "annotation-link";
})(TestIds || (TestIds = {}));